module.exports = __webpack_public_path__ + "img/add_video.c6bf969f.png";